import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { FixedAsset, FixedAssetDetail, Pager } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2040. 固定資産一覧詳細
 * [GET] /workspaces/:identifier/fixed_assets/:id
 */
type Props = {
  identifier: string;
  id: number;
};

type FixedAssetResp = {
  fixed_asset: FixedAsset;
  fixed_asset_details: FixedAssetDetail[];
};

const fixedAsset = (props: Props): Promise<FixedAssetResp> => {
  return axios.get(`/api/workspaces/${props.identifier}/fixed_assets/${props.id}`);
};

export const useFixedAsset = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'fixed_assets', props.id],
    queryFn: () => fixedAsset(props),
  });
};
